const PLANS = {
    "sky-villa": {
        viewBox: "0 0 420 300",
        rooms: [
            { x: 16, y: 16, w: 190, h: 110, label: "Living · Dining" },
            { x: 206, y: 16, w: 90, h: 64, label: "Kitchen" },
            { x: 296, y: 16, w: 108, h: 110, label: "Sky Deck" },
            { x: 206, y: 80, w: 90, h: 46, label: "Foyer" },
            { x: 16, y: 126, w: 130, h: 158, label: "Primary Suite" },
            { x: 146, y: 126, w: 120, h: 72, label: "Bedroom 02" },
            { x: 146, y: 198, w: 120, h: 86, label: "Bedroom 03" },
            { x: 266, y: 126, w: 60, h: 72, label: "Bath" },
            { x: 326, y: 126, w: 78, h: 158, label: "Lounge" },
            { x: 266, y: 198, w: 60, h: 86, label: "Utility" },
        ],
    },
    penthouse: {
        viewBox: "0 0 420 300",
        rooms: [
            { x: 16, y: 16, w: 220, h: 120, label: "Great Room" },
            { x: 236, y: 16, w: 80, h: 64, label: "Kitchen" },
            { x: 316, y: 16, w: 88, h: 268, label: "Terrace" },
            { x: 236, y: 80, w: 80, h: 56, label: "Dining" },
            { x: 16, y: 136, w: 140, h: 148, label: "Primary Suite" },
            { x: 156, y: 136, w: 90, h: 72, label: "Suite 02" },
            { x: 156, y: 208, w: 90, h: 76, label: "Suite 03" },
            { x: 246, y: 136, w: 70, h: 72, label: "Suite 04" },
            { x: 246, y: 208, w: 70, h: 76, label: "Lounge" },
        ],
    },
    duplex: {
        viewBox: "0 0 420 300",
        rooms: [
            { x: 16, y: 16, w: 130, h: 110, label: "Living (Lower)" },
            { x: 16, y: 126, w: 130, h: 60, label: "Kitchen (Lower)" },
            { x: 16, y: 186, w: 130, h: 98, label: "Guest Suite" },
            { x: 146, y: 16, w: 44, h: 268, label: "Stair" },
            { x: 190, y: 16, w: 214, h: 110, label: "Primary Suite (Upper)" },
            { x: 190, y: 126, w: 104, h: 72, label: "Suite (Upper)" },
            { x: 294, y: 126, w: 110, h: 72, label: "Family (Upper)" },
            { x: 190, y: 198, w: 214, h: 86, label: "Double-height Deck" },
        ],
    },
};

export default function FloorPlan({ planId, title }) {
    const plan = PLANS[planId];
    if (!plan) return null;
    return (
        <div className="overflow-hidden rounded-2xl border border-black/10 bg-obsidian/70 p-4">
            <svg
                viewBox={plan.viewBox}
                className="h-auto w-full"
                role="img"
                aria-label={title ? `${title} floor plan` : "Floor plan"}
            >
                {plan.rooms.map((r) => (
                    <g key={r.label}>
                        <rect
                            x={r.x}
                            y={r.y}
                            width={r.w}
                            height={r.h}
                            rx="4"
                            fill="rgba(28,37,52,0.03)"
                            stroke="rgba(201,111,74,0.5)"
                            strokeWidth="1"
                        />
                        <text
                            x={r.x + r.w / 2}
                            y={r.y + r.h / 2}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill="#57616F"
                            fontSize="9"
                            fontFamily="'JetBrains Mono', monospace"
                            letterSpacing="0.5"
                        >
                            {r.label}
                        </text>
                    </g>
                ))}
            </svg>
        </div>
    );
}
